export default __webpack_public_path__ + "static/media/CPlus.9002a804.png";